exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-slider{width:100%;height:100%;position:relative;overflow:hidden}.vue-slider-ul{height:100%;overflow:hidden;padding:0;margin:0;-webkit-transition:.2s;transition:.2s;width:100000px}.vue-slider-ul-li{padding:0;margin:0;float:left;height:100%}.vue-slider-ul-li>div{height:100%;text-align:center}.vue-slider-ul-li>a{display:block;width:100%;padding:0;margin:0}.vue-slider-ul-li img{height:100%;width:100%}.vue-slider-index{overflow:hidden;position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);bottom:5%}.vue-slider-index-li{width:1.28px;width:.08rem;height:1.28px;height:.08rem;border-radius:50%;background-color:hsla(0,0%,100%,.5);float:left;margin-right:2.432px;margin-right:.152rem}.vue-slider-index-li.on{background-color:#fff}@media screen and (min-width:800px){.vue-slider-ul-li img{height:100%;width:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-2!./node_modules/postcss-loader??ref--5-3!./node_modules/sass-loader/dist/cjs.js??ref--5-4!./components/scss/scrollList.scss
// module id = yUC5
// module chunks = 7